import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function Pagination({
  currentPage,
  totalPages,
  totalEntries,
  onPageChange,
}) {
  const itemsPerPage = 10;

  const getDisplayedPages = () => {
    const pages = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1); // Always show the first page

      if (currentPage > 3) {
        pages.push("..."); // Add ellipsis if there are pages between 1 and currentPage - 1
      }

      if (currentPage > 2) {
        pages.push(currentPage - 1); // Add the page before the current page
      }

      if (currentPage !== 1 && currentPage !== totalPages) {
        pages.push(currentPage); // Add the current page if it's not the first or last page
      }

      if (currentPage < totalPages - 1) {
        pages.push(currentPage + 1); // Add the page after the current page
      }

      if (currentPage < totalPages - 2) {
        pages.push("..."); // Add ellipsis if there are pages between currentPage + 1 and totalPages
      }

      if (totalPages !== 1) {
        pages.push(totalPages); // Always show the last page
      }
    }
    return pages;
  };

  const displayedPages = getDisplayedPages();

  return (
    <div className="bg-white px-6 py-4 flex items-center justify-between border-t border-gray-200">
      <div className="text-sm text-gray-500">
        Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
        {Math.min(currentPage * itemsPerPage, totalEntries)} of {totalEntries} entries
      </div>
      <div className="flex items-center space-x-2">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="p-1 rounded-md border border-gray-300 text-gray-500 hover:bg-gray-50"
        >
          <ChevronLeft size={20} />
        </button>
        {displayedPages.map((p, index) =>
          p === "..." ? (
            <span key={index} className="w-8 h-8 flex items-center justify-center text-gray-500">
              ...
            </span>
          ) : (
            <button
              key={p}
              onClick={() => onPageChange(p)}
              className={`w-8 h-8 flex items-center justify-center rounded-md ${p === currentPage
                ? "bg-[#2962FF] text-white"
                : "text-gray-700 hover:bg-gray-100"
                }`}
            >
              {p}
            </button>
          )
        )}
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="p-1 rounded-md border border-gray-300 text-gray-500 hover:bg-gray-50"
        >
          <ChevronRight size={20} />
        </button>
      </div>
    </div>
  );
}
